module.exports = __webpack_public_path__ + "img/proyek-dashboard.bd6740b5.svg";